module.exports = __webpack_public_path__ + "images/insights-nav-icon-ec0a0bba.svg";